import { DText } from "./DText";

export function DTextError({ error }: { error: string }) {
    return error.length > 0 ? <DText style={{ color: 'red', paddingTop: 5, fontSize: 10 }}> {`( Some error:${error})`}</DText> : null
}